import { render, staticRenderFns } from "./WrongBook.vue?vue&type=template&id=18537b66&scoped=true&"
import script from "./WrongBook.vue?vue&type=script&lang=js&"
export * from "./WrongBook.vue?vue&type=script&lang=js&"
import style0 from "./WrongBook.vue?vue&type=style&index=0&id=18537b66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18537b66",
  null
  
)

export default component.exports